
<template>
  <div>
    <div>
      <b-card>
        <b-form
            ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain"
        >

          <b-form-group
              label="نام محتوا "
          >
            <b-form-input
                placeholder="این نام داخل اپلیکیشن نمایش داده نمی شود "
                v-model="data.name"
            />

          </b-form-group>

          <b-form-group
              label="متن سوال "
          >
            <b-form-input
                placeholder="متن سوال"
                v-model="data.questionText"
            />

          </b-form-group>

          <b-form-group
              label="فایل سوال"

          >
            <b-form-file
                v-model="questionsFile"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".jpg,.svg, .png,.mp3,.mp4"
            />

          </b-form-group>


          <!-- Row Loop -->
          <b-row
              v-for="(poll, index) in data.options"
              :id="poll.id"
              :key="poll.id"
              ref="row"
          >

            <!-- Item Name -->
            <b-col md="4">
              <b-form-group
                  label="متن گزینه"
              >
                <b-form-input
                    id="item-name"
                    type="text"
                    v-model="poll.text"
                    placeholder="لطفا متن گزینه را وارد کنید"
                />
              </b-form-group>
            </b-col>

            <!-- Item Name -->
            <b-col md="4">
              <b-form-group
                  label="فایل گزینه"

              >
                <b-form-file
                    v-model="File"
                    placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                    drop-placeholder="Drop file here..."
                    accept=".jpg, .svg,  .png,.mp3,.mp4"
                />

              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
class="mt-2"
              >
                <b-form-radio
                    v-model="poll.status"
                    plain
                    name="some-radios3"
                    value="true"
                >
                  درست
                </b-form-radio>
                <b-form-radio
                    v-model="poll.status"
                    plain
                    name="some-radios3"
                    value="false"
                >
                  غلط
                </b-form-radio>

              </b-form-group>
            </b-col>



            <!-- submit button-->
            <b-col
                md="1"
                class="mb-50"
            >
              <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-success"
                  style="margin-top: 27.5px !important;"
                  @click="submitItem()"
              >
                <feather-icon
                    icon="CheckIcon"
                    class="mr-25"
                />
                <span>ثبت</span>
              </b-button>

            </b-col>






            <!-- Remove Button -->
            <b-col
                md="1"
                class="mb-50"
            >
              <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  style="margin-top: 27.5px !important;"
                  @click="removeItem(index)"
              >
                <feather-icon
                    icon="XIcon"
                    class="mr-15"
                />
                <span>حذف</span>
              </b-button>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>

        </b-form>


      </b-card>
    </div>
<!--    <b-button-->
<!--        v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
<!--        variant="primary"-->
<!--        @click="repeateAgain"-->
<!--    >-->
<!--      <feather-icon-->
<!--          icon="PlusIcon"-->
<!--          class="mr-25"-->
<!--      />-->
<!--      <span>اضافه کردن جواب</span>-->
<!--    </b-button>-->
    <b-form-group>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          class="mr-1 mt-1"
          @click="SaveContent"
      >
        ثبت
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import {
  BForm, BFormGroup,BFormFile,BFormRadio , BFormInput,BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import uploadService from "@/modules/services/uploadService";

export default {
  components: {
    BForm,
    BRow,BFormFile,
    BCol,
    BCard,
    BFormRadio,
    BButton,
    BFormGroup,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      questionsFile:undefined,
      File:undefined,
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
      nextTodoId: 2,
      optionText:'',
      optionfile:'',
      optionstatus:undefined,
      data:{
        name:'',
        questionText:'',
        questionFileAddress:'',
        options:[
          {
            fileAddress:'',
            text:'',
            status: false,
          }
        ],

      }
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },



  methods: {
    async submitItem(){
      let optionfile = '';

      if (this.File){
        optionfile = await uploadService.upload(this.file);
      }
      this.data.options.push({
        fileAddress:'',
        text:optionfile,
        status: false
      })
      console.log(this.data.options);

      this.repeateAgain();
    },
    async SaveContent(event) {
      if (this.questionsFile){
        this.data.questionFileAddress = await uploadService.upload(this.questionsFile);
      }
      this.$emit('examFormSubmit', this.data)
    },
    repeateAgain() {


      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.data.options.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
